var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencilIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2434_7047)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7236 2.05718C12.5636 2.05718 12.4051 2.08871 12.2572 2.14997C12.1093 2.21123 11.9749 2.30101 11.8617 2.4142L2.98691 11.289L2.34046 13.6593L4.71076 13.0129L13.5856 4.13806C13.6988 4.02487 13.7886 3.89049 13.8498 3.7426C13.9111 3.59472 13.9426 3.43621 13.9426 3.27613C13.9426 3.11605 13.9111 2.95755 13.8498 2.80966C13.7886 2.66177 13.6988 2.52739 13.5856 2.4142C13.4724 2.30101 13.338 2.21123 13.1901 2.14997C13.0422 2.08871 12.8837 2.05718 12.7236 2.05718ZM11.7469 0.918127C12.0566 0.789863 12.3885 0.723846 12.7236 0.723846C13.0588 0.723846 13.3907 0.789863 13.7004 0.918127C14.01 1.04639 14.2914 1.23439 14.5284 1.47139C14.7654 1.70839 14.9534 1.98976 15.0817 2.29941C15.2099 2.60907 15.2759 2.94096 15.2759 3.27613C15.2759 3.6113 15.2099 3.94319 15.0817 4.25285C14.9534 4.56251 14.7654 4.84387 14.5284 5.08087L5.52839 14.0809C5.44635 14.1629 5.34432 14.2221 5.23239 14.2526L1.56573 15.2526C1.33492 15.3156 1.08808 15.25 0.91891 15.0809C0.749744 14.9117 0.684191 14.6649 0.747139 14.4341L1.74714 10.7674C1.77767 10.6555 1.83687 10.5534 1.91891 10.4714L10.9189 1.47139C11.1559 1.23439 11.4373 1.04639 11.7469 0.918127Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2434_7047"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilIcon);
export default __webpack_public_path__ + "static/media/PencilIcon.6932ac7e4703148a071c1d92963d3f5a.svg";
export { ForwardRef as ReactComponent };